// src/store/store.js
import { configureStore } from "@reduxjs/toolkit";
import mealReducer from "./mealSlice";
import alertReducer from "./alertSlice";
import mealHistoryReducer from "./mealHistorySlice";

const store = configureStore({
  reducer: {
    meal: mealReducer,
    alert: alertReducer,
    mealHistory: mealHistoryReducer,
  },
});

export default store;
